import { render, staticRenderFns } from "./broadcastRecord.vue?vue&type=template&id=c313bf5c&scoped=true"
import script from "./broadcastRecord.vue?vue&type=script&lang=js"
export * from "./broadcastRecord.vue?vue&type=script&lang=js"
import style0 from "./broadcastRecord.vue?vue&type=style&index=0&id=c313bf5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c313bf5c",
  null
  
)

export default component.exports